module.exports = __webpack_public_path__ + "benchmark.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[name].[ext]!./~/benchmark/benchmark.js?
// module id = 87
// module chunks = 2